// Import Actions
import { SET_PRODUCTS } from './ProductActions.js';

// Initial State
export const initialState = {
    data: [],
};

const ProductReducer = (state = initialState, action) => {
    switch(action.type) {
        case SET_PRODUCTS:
            return {
                ...state,
                data: state.data.filter(existingProduct => !action.products.find(product => product._id === existingProduct._id)).concat(action.products),
            };

        default:
            return state;
    }
};

export default ProductReducer;
